import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

// JS Files
import MuiSelect from "../shares/MuiSelect";
import MuiButton from "../shares/MuiButton";
import { Province } from "../../Province";

// Others File

const LinksLeftSide = () => {
  const navigate = useNavigate();

  const [selectedProvince, setSelectedProvince] = useState(undefined);
  const [selectedCity, setSelectedCity] = useState(undefined);
  return (
    <>
      <div className="rounded-lg p-4 md:p-8 mt-2 md:mt-0 bg-myorange-50">
        <p className="font-bold text-lg text-mygray-600">
          مراکز پذیرش اسناد خسارت
        </p>
        <p className="text-sm mt-4 text-mygray-600">
          به منظور جست و جوی مراکز پذیرش اسناد خسارت، استان و شهر مربوطه را
          انتخاب نمایید.
        </p>
        <div className="mx-12 md:mx-20 mt-12">
          <div className="mt-8">
            <MuiSelect
              size="small"
              inputLabel="استان"
              labelId="province-label"
              id="province-select"
              label="province"
              menuItems={Province.map((it) => {
                return { name: it.name, value: it.value };
              })}
              onChange={(e) => {
                setSelectedProvince(e.target.value);
              }}
              value={selectedProvince}
            />
          </div>
          <div className="mt-12">
            <MuiSelect
              size="small"
              inputLabel="شهر"
              labelId="city-label"
              id="city-select"
              label="city"
              menuItems={
                selectedProvince !== undefined && selectedProvince !== ""
                  ? Province.filter(
                      (it) => it.value == selectedProvince
                    )[0].cities.map((ci) => {
                      return {
                        name: ci,
                        value: ci,
                      };
                    })
                  : []
              }
              onChange={(e) => {
                setSelectedCity(e.target.value);
              }}
              value={selectedCity}
            />
          </div>
          <div className="flex justify-center mt-12">
            <MuiButton
              onClick={() =>
                navigate(
                  selectedCity !== undefined
                    ? `/centers/${selectedProvince}/${selectedCity}`
                    : `/centers/${selectedProvince}`
                )
              }
              disabled={
                selectedProvince == undefined || selectedCity == undefined
              }
              type="submit"
              variant="contained"
              color="primary"
              text="مشاهده نتایج"
            />
          </div>
        </div>
      </div>
    </>
  );
};
export default LinksLeftSide;
